import React from 'react'

import {css} from '../../theme/css'
import {createSvgIcon} from '../utils'

const root = css`
  block-size: 30px;
  inline-size: 116px;
  mask-type: alpha;
`

export default createSvgIcon(
  <>
    <g clip-path="url(#a)">
      <mask id="b" x="0" y="0" width="29" height="30">
        <circle cx="14.444" cy="15" r="14.003" fill="#fff" />
      </mask>
      <g mask="url(#b)">
        <path fill="#FC3F1D" d="M.44.998h28.006v28.005H.44z" />
        <path
          d="M14.823 16.447c.818 1.792 1.091 2.416 1.091 4.568v2.854h-2.922v-4.811L7.479 7.066h3.048l4.296 9.38Zm3.604-9.38-3.575 8.123h2.971l3.585-8.124h-2.98Z"
          fill="#fff"
        />
      </g>
    </g>
    <path
      d="M34.837 6.233V24h3.912c4.908 0 8.436-3.17 8.436-8.973 0-6.544-3.503-8.794-8.18-8.794h-4.168Zm3.656 15.364h-.562V8.637h.818c3.118 0 5.291 1.558 5.291 6.339 0 4.397-2.198 6.621-5.547 6.621Zm20.641 1.534v-2.48c-.946.64-2.53 1.202-4.013 1.202-2.224 0-3.068-1.048-3.196-3.196h7.337v-1.61c0-4.474-1.968-6.161-5.01-6.161-3.707 0-5.471 2.837-5.471 6.723 0 4.474 2.198 6.647 6.084 6.647 1.943 0 3.375-.511 4.27-1.125ZM54.2 13.29c1.509 0 1.969 1.252 1.969 2.863v.256h-4.244c.077-2.046.818-3.12 2.275-3.12Zm10.142-7.056H61.3V24h3.043V6.233Zm4.059 3.323c.997 0 1.79-.69 1.79-1.79 0-1.073-.793-1.789-1.79-1.789s-1.764.716-1.764 1.79c0 1.1.767 1.79 1.764 1.79Zm-1.508 1.585v12.86h3.042V11.14h-3.043Zm4.186 0 3.937 12.86h3.936l3.937-12.86h-2.94l-2.786 9.843L74.3 11.14h-3.221Zm22.557 11.99v-2.48c-.946.64-2.53 1.202-4.013 1.202-2.225 0-3.068-1.048-3.196-3.196h7.337v-1.61c0-4.474-1.968-6.161-5.01-6.161-3.707 0-5.471 2.837-5.471 6.723 0 4.474 2.198 6.647 6.084 6.647 1.943 0 3.374-.511 4.27-1.125Zm-4.934-9.842c1.508 0 1.969 1.252 1.969 2.863v.256h-4.244c.077-2.046.818-3.12 2.275-3.12Zm10.142 2.684c.844-1.56 2.097-2.352 3.963-2.25V10.86c-1.739.103-3.17 1.15-3.886 2.838h-.077l-.076-2.557h-2.966v12.86h3.042v-8.028Zm7.632 11.99c2.837 0 3.885-2.02 4.755-4.653l4.013-12.169h-2.94l-2.837 9.664-2.838-9.664h-3.196l4.423 13.422c-.332.613-.818.997-1.662.997-.562 0-1.048-.18-1.38-.512v2.48s.46.435 1.662.435Z"
      fill="#21201F"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.44 .998)" d="M0 0h28.005v28.005H0z" />
      </clipPath>
    </defs>
  </>,
  'DostavkaEnLogoExpanded',
  {className: root, viewBox: '0 0 116 30'},
)
